<template>
  <mescroll-vue :up="getscrollData()" @init="initScroll" :down="mescrollDown">
    <div class="list" id="dataList">
      <div
        to="/"
        v-for="(item, index) in knowData"
        :key="index"
        @click="toKnowUri(item)"
      >
        <search-cell :msg="item | formatData"></search-cell>
      </div>
    </div>
  </mescroll-vue>
</template>
<script>
import SearchCell from "./searchCell.vue";
import MescrollVue from "mescroll.js/mescroll.vue";
import pub_methods from "./mixins/pub_methods.js";
export default {
  name: "knowledges",
  mixins: [pub_methods],
  data() {
    return {
      knowData: [],
    };
  },
  components: {
    SearchCell,
    MescrollVue,
  },
  methods: {
    upCallback(page, mescroll) {
      this.getKnowData(page.num, page.size, "", mescroll);
    },
    getKnowData(pageNum, pageSize, keyword, mescroll) {
      let _this = this;
      let url = "index.php/mobile/search/knowledge-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage._sys_id || 5,
        language: localStorage.getItem("_user_data_language"),
        size: pageSize,
        page: pageNum,
        keyword: _this.$store.state.searchWord,
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          let data = res.data.result.data;
          if (pageNum == 1) {
            _this.knowData = [];
          }
          _this.knowData = _this.knowData.concat(data);
          _this.$nextTick(() => {
            if (pageNum > res.data.result.pages.page_count) {
              mescroll.endSuccess(data.length, false);
            } else {
              mescroll.endSuccess(data.length, true);
            }
          });
        }
      });
    },
    toKnowUri(item) {
      this.$router.push({
        path: "/main/knowledge_exchange/detail",
        query: { id: item.id },
      });
    },
  },
  filters: {
    formatData(item) {
      return {
        type: item.type,
        trainplan_name: item.category_name,
        name: item.title,
      };
    },
  },
};
</script>

<style lang="less" scoped>
#dataList {
  /deep/.mescroll-empty {
    height: 90vh;
    background: #fff;
    .empty-icon {
      margin: 1rem auto 0;
    }
  }
}
</style>
